export const normalizeExternalUrl = (value: string): string | undefined => {
  try {
    const url = new URL(value.trim());
    if (!['http:', 'https:'].includes(url.protocol)) {
      return undefined;
    }

    return url.toString();
  } catch (error) {
    return undefined;
  }
};
